var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal',{attrs:{"to":"sidebar-menu"}},[_c('nav-list',{attrs:{"items":_vm.navigationItems}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }